module.exports = __webpack_public_path__ + "img/kankou_13.6225c822.jpg";